import { createEmailSchema } from "@/shared/lib/validation/user-schemas";
import { z } from "zod";

// Factory 함수로 번역된 스키마 생성
export const createInquiryFormSchema = (t: (key: string) => string) => {
  return z.object({
    name: z.string().min(1, t("f_cu_err_name")),
    contact: z.string().min(1, t("f_cu_err_phone")),
    company: z.string().min(1, t("f_cu_err_hosn")),
    email: createEmailSchema(t),
    title: z.string().min(1, t("f_cu_err_title")),
    content: z.string().min(1, t("f_cu_err_context")),
    agreePrivacy: z.boolean().refine((val) => val === true, t("f_cu_err_agree")),
  });
};

// 기본 스키마 (fallback용)
export const inquiryFormSchema = createInquiryFormSchema((key) => key);

export type InquiryFormValues = z.infer<ReturnType<typeof createInquiryFormSchema>>;
